import { render, staticRenderFns } from "./addMerchantComponent.vue?vue&type=template&id=08615ac5&"
import script from "./addMerchantComponent.vue?vue&type=script&lang=js&"
export * from "./addMerchantComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports